import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _LazyCookiesBanner;
import { ApolloProvider } from '@apollo/client';
import { AmplitudeProvider } from '@crehana/analytics';
// web
import { useApolloClient } from '@crehana/apollo-client';
import { AuthCentralizedProvider, AuthProvider } from '@crehana/auth';
import { envVars } from '@crehana/constants/env-vars';
import { I18nProvider } from '@crehana/i18n';
import { RBACProvider } from '@crehana/rbac/provider';
import { LANGUAGES } from '@crehana/ts-types';
import { Layout as CrehanaUILayout } from '@crehana/ui';
import { Channels } from "./Channels";
import { LazyCookiesBanner } from "./CookiesBanner";
import { RootErrorBoundaryWithSentry } from "./ErrorBoundaries";
import { OrganizationBrandingProvider } from "./organization-branding-provider";
import { TrackingProvider } from "./TrackingContext";
import { UIThemeProvider } from "./UITheme";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CrehanaLayout = function CrehanaLayout(_ref) {
  var children = _ref.children,
    initialApolloState = _ref.initialApolloState,
    countryCode = _ref.countryCode,
    pageKey = _ref.pageKey,
    i18nProviderProps = _ref.i18nProviderProps,
    renderCookiesBanner = _ref.renderCookiesBanner,
    isErrorPage = _ref.isErrorPage,
    sentryInstance = _ref.sentryInstance,
    amplitudeApiKey = _ref.amplitudeApiKey,
    organizationSlug = _ref.organizationSlug;
  var apolloClient = useApolloClient(initialApolloState, countryCode, pageKey);
  return /*#__PURE__*/_jsx(RootErrorBoundaryWithSentry, {
    sentryInstance: sentryInstance,
    children: /*#__PURE__*/_jsx(ApolloProvider, {
      client: apolloClient,
      children: /*#__PURE__*/_jsx(AuthProvider, {
        onLogout: function onLogout() {
          window.location.href = "/logout/?next=".concat(window.location.pathname);
        },
        meQueryOptions: {
          skip: isErrorPage
        },
        children: /*#__PURE__*/_jsx(AuthCentralizedProvider, {
          organizationSlug: organizationSlug,
          children: /*#__PURE__*/_jsxs(OrganizationBrandingProvider, {
            children: [/*#__PURE__*/_jsx(Channels, {
              countryCode: countryCode || ''
            }), /*#__PURE__*/_jsx(CrehanaUILayout, {
              children: /*#__PURE__*/_jsx(TrackingProvider, {
                children: /*#__PURE__*/_jsx(AmplitudeProvider, {
                  apiKey: amplitudeApiKey || envVars.AMPLITUDE_API_KEY || process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
                  children: /*#__PURE__*/_jsx(UIThemeProvider, {
                    children: /*#__PURE__*/_jsxs(I18nProvider, _objectSpread(_objectSpread({
                      languageCode: LANGUAGES.ES,
                      fallbackNs: ['main-menu']
                    }, i18nProviderProps), {}, {
                      children: [/*#__PURE__*/_jsx(RBACProvider, {
                        children: children
                      }), renderCookiesBanner ? _LazyCookiesBanner || (_LazyCookiesBanner = /*#__PURE__*/_jsx(LazyCookiesBanner, {})) : null]
                    }))
                  })
                })
              })
            })]
          })
        })
      })
    })
  });
};